import React from 'react'

import { Alert } from '@vtex/shoreline'

import { Wrapper } from './styles'

const PanelStatusPending = () => (
  <Alert variant="warning">
    <Wrapper>Este pedido contém itens com status pendentes.</Wrapper>
  </Alert>
)

export default PanelStatusPending
